import { createAction } from 'redux-actions';
import * as types from './power-bi-constants';

export const fetchPowerBiReports = createAction(types.FETCH_POWER_BI_REPORTS_REQUEST);
export const fetchPowerBiReportsSuccess = createAction(types.FETCH_POWER_BI_REPORTS_SUCCESS);
export const fetchPowerBiReportsFailure = createAction(types.FETCH_POWER_BI_REPORTS_FAILURE);
